"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const theme_1 = __importDefault(require("../../styles/theme"));
const styles = react_native_1.StyleSheet.create({
    info: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: 10,
        marginTop: 4,
    },
    textBoxInput: {
        color: theme_1.default.colors.COLOR_GRAY_DARK,
        backgroundColor: theme_1.default.colors.COLOR_WHITE,
    },
    // password input
    iconMargin: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        padding: react_native_1.Platform.OS === 'web' ? 5 : 20,
        marginBottom: react_native_1.Platform.OS === 'web' ? 0 : 10,
    },
    iconPosition: {
        position: 'absolute',
        right: 0,
        top: 15,
        bottom: 0,
    },
    // PICKER STYLES
    containerBanks: {
        flexDirection: 'row',
        flex: 1,
    },
    bankLogo: {
        borderRadius: 0,
        backgroundColor: theme_1.default.colors.COLOR_WHITE,
    },
    picker: {
        backgroundColor: theme_1.default.colors.COLOR_WHITE,
        marginLeft: 5,
        color: theme_1.default.colors.COLOR_BLACK,
        borderWidth: 0,
    },
    valueContainer: {
        flex: 1,
        justifyContent: 'center',
        alignContent: 'center',
        borderWidth: 2,
        borderColor: theme_1.default.colors.COLOR_GRAY_LIGHT,
        paddingVertical: 15,
    },
    sliderContainer: {
        flex: 1,
        justifyContent: 'center',
        alignContent: 'center',
    },
    subtitleText: {
        color: theme_1.default.colors.COLOR_GRAY,
        marginBottom: 20,
        paddingHorizontal: 10,
    },
    flexStartLeft: {
        justifyContent: 'flex-start',
        textAlign: 'left',
    },
    flexEndRight: {
        justifyContent: 'flex-end',
        textAlign: 'right',
    },
});
exports.default = styles;
